import { useSelector } from "react-redux"
import { useState, useEffect } from "react"
import { useTour } from "../../context/TourContext.js"
import { textReminder } from "../../utils/tutorialSteps.js"
import { TutorialPopover } from "./index.2.0.jsx"
import { useMediaQuery } from "@custom-react-hooks/use-media-query"
import { useDispatch } from "react-redux"
import { setShowTextReminder } from "../../state/index.js"

export const ReminderController = () => {
    const isDesktop = useMediaQuery(process.env.REACT_APP_IS_DESKTOP);
    const showTextReminder = useSelector(state => state.showTextReminder ?? false)
    const dispatch = useDispatch()
    const { getEntry, subscribe } = useTour()
    const [, forceTick] = useState(0)

    const resolveResponsive = (value, fallback) => {
        if (Array.isArray(value)) {
            const [mobile, desktop] = value
            const resolved = isDesktop ? desktop : mobile
            return resolved !== undefined ? resolved : fallback
        }
        return value !== undefined ? value : fallback
    }

    useEffect(() => {
        return subscribe(() => forceTick(t => t + 1))
    }, [subscribe])

    const config = textReminder

    if (!config || !showTextReminder) return null

    let entry = null
    if (config.target) {
        entry = getEntry(config.target)
        if (!entry) return null
    }

    return (
        <TutorialPopover
            description={config.description}
            anchorRef={entry ? { current: entry.el } : { current: null }}
            onNext={() => {
                dispatch(setShowTextReminder(false))
            }}
            type="nudge"
            dismissable={config.dismissable ?? false}
            placement={resolveResponsive(config.placement, "top")}
            spotlightPadding={resolveResponsive(config.padding, 8)}
            spotlightMode={resolveResponsive(config.spotlightMode, "spotlight")}
            className={resolveResponsive(config.className, "")}
            hideArrow={resolveResponsive(config.hideArrow, false)}
            top={resolveResponsive(config.top, 0)}
            bottom={resolveResponsive(config.bottom, 0)}
            right={resolveResponsive(config.right, 0)}
            left={resolveResponsive(config.left, 0)}
            disableScroll={resolveResponsive(config.disableScroll, false)}
            delay={resolveResponsive(config.delay, 600)}
            config={resolveResponsive(config.config, 0)}
            totalSteps={resolveResponsive(config.totalSteps, 5)}
            buttonContent={resolveResponsive(config.buttonContent, "はじめる")}
        />
    )
}